var o;
(function(t) {
  t.QUIZ = "QUIZ", t.FORM = "FORM";
})(o || (o = {}));
var e;
(function(t) {
  t.TEXT = "TEXT", t.IMAGE = "IMAGE";
})(e || (e = {}));
const i = {
  mobilePosition: 20,
  autoShowDelay: 30,
  themeColor: "#ff0000",
  quiz: {
    title: "РАСCЧИТАЙТЕ СТОИМОСТЬ ТЕПЛИЦЫ",
    button: "Рассчитайте стоимость",
    formTitle: "Предварительная стоимость теплицы сформирована. Для точного расчета цены нам осталось уточнить некоторые детали. Укажите свой номер телефона, мы свяжемся с вами и предложим лучшую цену?"
  },
  form: {
    title: "ЗАКАЖИТЕ ЗВОНОК (ЭТО БЕСПЛАТНО)",
    subtitle: "Ваша заявка будет обработана в порядке очереди. Мы обязательно свяжемся с вами!",
    button: "Закажите бесплатный звонок"
  }
};
export {
  e as AnswerType,
  i as defaultProps
};
